import React, { useState } from 'react';
import './Account.css';
import AccountSidebar from './components/AccountSidebar';
import AccountDashboard from './components/AccountDashboard';
import BookingSystem from './components/BookingSystem';
import History from './components/History';
import Quotes from './components/Quotes';
import Invoices from './components/Invoices';
import Profile from './components/Profile';

const Account = ({ user, authForm, vehicle, setCurrentPage }) => {
    const [currentTab, setCurrentTab] = useState('dashboard');

    const renderContent = () => {
        switch (currentTab) {
            case 'dashboard':
                return <AccountDashboard user={user} vehicle={vehicle} />;
            case 'booking':
                return <BookingSystem user={user} />;
            case 'history':
                return <History user={user} />;
            case 'quotes':
                return <Quotes user={user} />;
            case 'invoices':
                return <Invoices user={user} />;
            case 'profile':
                return <Profile user={user} authForm={authForm} />;
            default:
                return <AccountDashboard user={user} vehicle={vehicle} />;
        }
    };

    return (
        <div className="account-layout">
            <AccountSidebar
                currentTab={currentTab}
                onTabChange={setCurrentTab}
                userName={user?.name}
                onNavigateHome={() => setCurrentPage('accueil')}
            />
            <main className="account-main-content">
                {renderContent()}
            </main>
        </div>
    );
};

export default Account;

